import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'fuse-loading-bar',
    standalone: true,
    template: `<div class="fuse-loading-bar"></div>`,
    styles: [
        `
      .fuse-loading-bar {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 4px;
        background: linear-gradient(90deg, #0088cc, #48b1bf);
        animation: fuse-loading-bar-stripes 1.5s linear infinite;
        z-index: 1000;
      }

      @keyframes fuse-loading-bar-stripes {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(100%);
        }
      }
    `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FuseLoadingBarComponent { }



